<div class="standard-dialog min-w-[450px]">
  <div class="header" mat-dialog-title>
    <div class="title-section">
      <h2>{{ 'GroupOverview.AddMembersTitle' | translate }}</h2>
      <p class="subtitle">{{ 'GroupOverview.AddMembersSubtitle' | translate }}</p>
    </div>
    <button mat-icon-button (click)="onCancel()" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="form-content flex flex-col gap-4 max-h-[450px] overflow-hidden">
    <!-- Search and Select All -->
    <div class="flex items-center gap-3">
      <div class="flex-1">
        <ui-input [placeholder]="'GroupOverview.SearchUser' | translate" [prefixIcon]="'search'" autocomplete="off" (valueChange)="onSearch($event)" />
      </div>
      @if (filteredUsers().length > 0) {
        <div class="flex items-center gap-2 cursor-pointer select-none" (click)="toggleSelectAll()">
          <ui-checkbox [checked]="isAllFilteredSelected()" (checkedChange)="toggleSelectAll()" />
          <span class="text-sm font-semibold text-[var(--skz-text-primary)]">
            {{ 'Global.SelectAll' | translate }}
          </span>
        </div>
      }
    </div>

    <!-- Scrollable Users list -->
    <div class="flex-1 overflow-y-auto custom-scrollbar max-h-[300px]">
      @if (loading()) {
        <div class="flex items-center justify-center p-8">
          <mat-spinner diameter="36" />
        </div>
      } @else {
        <div class="flex flex-col">
          @for (user of filteredUsers(); track user.uid) {
            <div
              (click)="toggleUserSelection(user.uid)"
              class="flex items-center justify-between p-2 border-b border-[var(--skz-border-color-secondary)] last:border-b-0 rounded-[var(--skz-radius-low)] hover:bg-[var(--skz-highlighted-item-color-lighter)] cursor-pointer transition-colors"
            >
              <div class="flex items-center gap-3">
                <img [src]="user.picture || 'assets/images/no_user.png'" alt="avatar" class="w-9 h-9 rounded-full object-cover border border-[var(--skz-border-color-main)]" />
                <div class="flex flex-col">
                  <span class="text-sm font-semibold text-[var(--skz-text-primary)]">{{ user.name }}</span>
                  <span class="text-xs text-[var(--skz-text-secondary)]">{{ user.email }}</span>
                </div>
              </div>
              <ui-checkbox [checked]="isUserSelected(user.uid)" (checkedChange)="toggleUserSelection(user.uid)" />
            </div>
          } @empty {
            <div class="flex flex-col items-center justify-center p-8 text-center text-[var(--skz-text-secondary)]">
              <mat-icon class="text-4xl mb-2 text-gray-400">group_off</mat-icon>
              <span>{{ 'GroupOverview.NoUsersFound' | translate }}</span>
            </div>
          }
        </div>
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="footer">
    <div class="left-actions">
      @if (selectedUserIds().size > 0) {
        <span class="text-xs font-semibold text-[var(--skz-icon-color-blue)]">{{ selectedUserIds().size }} {{ 'GroupOverview.SelectedCount' | translate }}</span>
      }
    </div>
    <div class="right-actions">
      <button mat-flat-button btnType="neutral" (click)="onCancel()">
        {{ 'Global.Cancel' | translate }}
      </button>
      <button mat-flat-button btnType="action" [disabled]="selectedUserIds().size === 0" (click)="onConfirm()">
        {{ 'Global.Add' | translate }}
      </button>
    </div>
  </mat-dialog-actions>
</div>
